export enum StatusTournament {
  PENDING = "PENDING",
  LIVE = "LIVE",
  PASSED = "PASSED",
}
